import React from "react"
import PropTypes from "prop-types"
import Ticket from "./Ticket"

import "./styles/TicketRepeater.css"

const TicketRepeater = ({vouchers, redemptionId}) => {
  return (
    <div className="ticket_productTickets">
      {vouchers.map((voucher, i) =>
        <div key={i} className="ticket_ticketWrapper tickets_borderBottom">
          <div className="ticket_ticketWrapperInner">
            <Ticket redemptionId={redemptionId} voucher={voucher} />
          </div>
        </div>
      )}
    </div>
  )
}

TicketRepeater.propTypes = {
  vouchers: PropTypes.array.isRequired,
  redemptionId: PropTypes.string.isRequired
}

export default TicketRepeater
